import { RefObject, useEffect, useRef, useState } from 'react';

const useDropdownButton = (
  visible?: boolean
): {
  dropdownRef: RefObject<HTMLDivElement>;
  dropdownVisible: boolean;
  toggleDropdown: () => void;
} => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  const [dropdownVisible, setDropdownVisible] = useState(Boolean(visible));

  const toggleDropdown = (): void => setDropdownVisible(!dropdownVisible);

  useEffect(() => {
    const closeDropdown = (e: MouseEvent): void => {
      if (visible) return;

      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener('click', closeDropdown, true);

    return (): void => {
      document.removeEventListener('click', closeDropdown, true);
    };
  }, [visible]);

  return {
    dropdownVisible,
    dropdownRef,
    toggleDropdown
  };
};

export default useDropdownButton;
